// Generated by CoffeeScript 2.4.1
(function() {
  var Promise, PubSub, Weaver, _, util;

  Promise = require('bluebird');

  PubSub = require('pubsub-js');

  util = require('./util');

  _ = require('lodash');

  Weaver = (function() {
    class Weaver {
      constructor(opts) {
        if (Weaver.instance != null) {
          throw new Error('Do not instantiate Weaver twice');
        }
        Weaver.instance = this;
        // Make Weaver objects available through the instance
        // FIXME: Should probably be done with a for loop or something
        this.Attribute = Weaver.Attribute;
        this.AttributeNode = Weaver.AttributeNode;
        this.Node = Weaver.Node;
        this.NodeList = Weaver.NodeList;
        this.DefinedNode = Weaver.DefinedNode;
        this.ACL = Weaver.ACL;
        this.CoreManager = Weaver.CoreManager;
        this.History = Weaver.History;
        this.Project = Weaver.Project;
        this.Query = Weaver.Query;
        this.QueryBuilder = Weaver.QueryBuilder;
        this.Sparql = Weaver.Sparql;
        this.Relation = Weaver.Relation;
        this.RelationNode = Weaver.RelationNode;
        this.Role = Weaver.Role;
        this.User = Weaver.User;
        this.Error = Weaver.Error;
        this.LegacyError = Weaver.LegacyError;
        this.Model = Weaver.Model;
        this.ModelClass = Weaver.ModelClass;
        this.ModelRelation = Weaver.ModelRelation;
        this.ModelQuery = Weaver.ModelQuery;
        this.ModelValidator = Weaver.ModelValidator;
        this.Branch = Weaver.Branch;
        this.Graph = Weaver.Graph;
        this.Sequence = Weaver.Sequence;
        this.Functions = Weaver.Functions;
        this.Shaper = Weaver.Shaper;
        this._connected = false;
        this._local = false;
        // Default options
        this._ignoresOutOfDate = false; // deprecated
        this._applicationSecret = null;
      }

      version() {
        return require('../package.json').version;
      }

      setApplicationSecret(applicationSecret) {
        return this._applicationSecret = applicationSecret;
      }

      getApplicationSecret() {
        return this._applicationSecret;
      }

      serverVersion() {
        return this.coreManager.serverVersion();
      }

      local(routes) {
        this._local = true;
        return this.coreManager.local(routes);
      }

      async connect(endpoint, options) {
        await this.coreManager.connect(endpoint, options);
        return this._connected = true;
      }

      isConnected() {
        return this._connected;
      }

      async disconnect() {
        await this.coreManager.disconnect();
        return this._connected = false;
      }

      getCoreManager() {
        return this.coreManager;
      }

      static GET() {
        return Weaver.getCoreManager().GET(...arguments);
      }

      static POST() {
        return Weaver.getCoreManager().POST(...arguments);
      }

      static STREAM() {
        return Weaver.getCoreManager().STREAM(...arguments);
      }

      async useProject(project) {
        var loaded;
        if (util.isString(project)) {
          loaded = (await Weaver.Project.load(project));
          return this.useProject(loaded);
        } else {
          this.coreManager.currentProject = project;
          return Promise.resolve();
        }
      }

      useBranch(branch) {
        return this.coreManager.currentBranch = branch;
      }

      resetBranch() {
        return this.useBranch(null);
      }

      static async cleanClose() {
        var e, errorCount, i, id, j, len, len1, list, ref, ref1, transaction, trxId;
        errorCount = 0;
        ref = Weaver.getCoreManager().currentOpenResultSets;
        for (list = i = 0, len = ref.length; i < len; list = ++i) {
          trxId = ref[list];
          for (j = 0, len1 = list.length; j < len1; j++) {
            id = list[j];
            try {
              console.warn(`Clean closing result set ${id} in transaction ${trxId}`);
              await Weaver.getCoreManager().releaseResultSet(trxId, id);
            } catch (error) {
              e = error;
              errorCount += 1;
            }
          }
        }
        try {
          ref1 = Weaver.getCoreManager().transactionMap;
          for (id in ref1) {
            transaction = ref1[id];
            try {
              console.warn(`Clean closing transaction ${id}`);
              await transaction.rollback();
            } catch (error) {
              e = error;
              errorCount += 1;
            }
          }
        } catch (error) {
          e = error;
          errorCount += 1;
        }
        if (errorCount > 0) {
          return console.warn(`Errors encountered closing resultsets and transactions: ${errorCount}`);
        }
      }

      async startTransaction(opts) {
        var branch, lockTimeoutSeconds, projectId, transaction, ttlSeconds;
        if (_.isObject(opts)) {
          if (opts.ttlSeconds != null) {
            ttlSeconds = opts.ttlSeconds;
          } else if (opts.ttl != null) {
            ttlSeconds = Math.ceil(opts.ttl / 1000);
          }
          branch = opts.branch;
          projectId = opts.project;
          lockTimeoutSeconds = opts.lockTimeoutSeconds;
        } else {
          // Backward compatibility with ttl being the sole argument
          ttlSeconds = Math.ceil(opts / 1000);
        }
        transaction = new Weaver.Transaction();
        if (ttlSeconds != null) {
          transaction.setTtlSeconds(ttlSeconds);
        }
        if (branch != null) {
          transaction.setBranch(branch);
        }
        if (projectId != null) {
          transaction.setProject(projectId);
        } else {
          transaction.setProject(this.coreManager.currentProject.id());
        }
        if (lockTimeoutSeconds != null) {
          transaction.setLockTimeoutSeconds(lockTimeoutSeconds);
        }
        await transaction.begin();
        this.coreManager.transactionMap[transaction.id()] = transaction;
        return transaction;
      }

      static useModel(model) {
        return Weaver.getCoreManager().currentModel = model;
      }

      static useIdentifier(name) {
        if (name === 'uuid' || name === 'cuid') {
          return Weaver.identifierStyle = name;
        } else {
          throw new Error('The supported types of identifier are uuid and cuid');
        }
      }

      static useTimeLibrary(name = 'moment') {
        if (name === 'native' || name === 'moment' || name === 'luxon') {
          return Weaver.timeLibrary = name;
        } else {
          throw new Error('The supported types of time library are [ native, moment, luxon ]');
        }
      }

      static prefixIdentifier(prefix) {
        return Weaver.identifierPrefix = prefix || '';
      }

      currentProject() {
        return this.coreManager.currentProject;
      }

      currentBranch() {
        return this.coreManager.currentBranch;
      }

      static currentModel() {
        return Weaver.getCoreManager().currentModel;
      }

      currentUser() {
        return this.coreManager.currentUser;
      }

      signOut() {
        return this.coreManager.signOutCurrentUser();
      }

      // Sign in using username and password
      signInWithUsername(username, password) {
        return this.coreManager.signInUsername(username, password);
      }

      // Sign in using email and password
      signInWithEmail(email, password) {
        return this.coreManager.signInEmail(email, password);
      }

      // Sign in using a JSON webtoken
      signInWithToken(authToken) {
        return this.coreManager.signInToken(authToken);
      }

      refreshToken(authToken) {
        return this.coreManager.refreshToken(authToken);
      }

      async wipe() {
        await this.coreManager.wipeProjects();
        await this.coreManager.destroyProjects();
        await this.coreManager.wipeUsers();
        return (await this.coreManager.wipeACL());
      }

      isSelfSignupEnabled() {
        return this.coreManager.isSelfSignupEnabled();
      }

      static activeUsersInMonth(month, year) {
        return Weaver.GET('users.activeInMonth', {month, year});
      }

      static activeUsersInPeriod(startDate, endDate) {
        return Weaver.GET('users.activeInPeriod', {startDate, endDate});
      }

      static getTrackDomains(startDate, endDate) {
        return Weaver.GET('domains.track', {startDate, endDate});
      }

      // Function is needed by the weaver-sdk-angular. This sets a callback
      // on the promise library for the digestion cycle to work.
      setScheduler(fn) {
        return Promise.setScheduler(fn);
      }

      // Returns the Weaver instance if instantiated. This should be called from
      // a static reference
      static getInstance() {
        if (!Weaver.instance) {
          throw new Error('Please instantiate Weaver before calling getInstance!');
        }
        return Weaver.instance;
      }

      // Returns the coremanager if Weaver is instantiated. This should be called from
      // a static reference
      static getCoreManager() {
        return Weaver.getInstance().getCoreManager();
      }

      // Shout a message to other connected clients
      static shout(message) {
        return Weaver.getCoreManager().shout(message);
      }

      // Listen to shouted messages
      static sniff(callback) {
        return Weaver.subscribe("socket.shout", callback);
      }

    };

    Weaver.identifierStyle = 'cuid';

    Weaver.timeLibrary = 'moment';

    Weaver.identifierPrefix = '';

    // Expose PubSub
    Weaver.subscribe = PubSub.subscribe;

    Weaver.unsubscribe = PubSub.unsubscribe;

    Weaver.publish = PubSub.publish;

    Weaver.clearAllSubscriptions = PubSub.clearAllSubscriptions;

    return Weaver;

  }).call(this);

  // Export
  module.exports = Weaver; // Node

  
  // Require Weaver objects after exporting Weaver to prevent circular dependency
  // issues
  module.exports.Node = require('./WeaverNode');

  module.exports.Attribute = require('./WeaverAttribute');

  module.exports.AttributeNode = require('./WeaverAttributeNode');

  module.exports.NodeList = require('./WeaverNodeList');

  module.exports.DefinedNode = require('./WeaverDefinedNode');

  module.exports.ACL = require('./WeaverACL');

  module.exports.Cache = require('./WeaverCache');

  module.exports.CoreManager = require('./CoreManager');

  module.exports.History = require('./WeaverHistory');

  module.exports.Project = require('./WeaverProject');

  module.exports.Query = require('./WeaverQuery');

  module.exports.QueryBuilder = require('./WeaverQueryBuilder');

  module.exports.Sparql = require('./WeaverSparql');

  module.exports.Relation = require('./WeaverRelation');

  module.exports.RelationNode = require('./WeaverRelationNode');

  module.exports.Role = require('./WeaverRole');

  module.exports.User = require('./WeaverUser');

  module.exports.Error = require('./WeaverError');

  module.exports.LegacyError = require('./Error');

  module.exports.Model = require('./WeaverModel');

  module.exports.ModelClass = require('./WeaverModelClass');

  module.exports.ModelRelation = require('./WeaverModelRelation');

  module.exports.ModelQuery = require('./WeaverModelQuery');

  module.exports.ModelValidator = require('./WeaverModelValidator');

  module.exports.Label = require('./WeaverLabel');

  module.exports.Transaction = require('./WeaverTransaction');

  module.exports.MetaQueries = require('./WeaverMetaQueries');

  module.exports.Graph = require('./WeaverGraph');

  module.exports.Branch = require('./WeaverBranch');

  module.exports.Sequence = require('./WeaverSequence');

  module.exports.Domain = require('./WeaverDomain');

  module.exports.Functions = require('./WeaverFunctions');

  module.exports.Shaper = require('./WeaverShaper');

}).call(this);
